import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/SEO"
import PageIllustration from "../partials/PageIllustration"
import HeroFeatures from "../partials/HeroFeatures"
import TrustedBy from "../partials/TrustedBy"
import TestimonialsCarousel from "../partials/TestimonialsCarousel"
import Cta from "../partials/Cta"
import Partners from "../partials/Partners"
import CalendlyBook from "../partials/CalendlyBook"
import Faqs from "../partials/Faqs"
import FeaturesZigzagList from "../partials/FeaturesZigzagList"
import ProcessSecurity from "../partials/ProcessSecurity"
import AIProductionAgent from "../partials/AIProductionAgent"
import HallOfFame from "../partials/HallOfFame"
import { useReferralUpdater } from "./referral-page-updater"
import { useTranslatedPage, useTranslatedPageData } from "../i18n/useTranslatedPage"

const PageFeature = ({ data, location }) => {
  const initialPage = useTranslatedPage(data.ghostPage)
  const translatedData = useTranslatedPageData(data.ghostPage.slug)
  const settings = data.allGhostSettings.edges[0].node
  const initialHtmlStringData = initialPage.html || ""
  const { updatedPage, updatedHtmlStringData } = useReferralUpdater(
    initialPage,
    initialHtmlStringData,
    location,
    settings,
  )
  const finalPage = updatedPage
  const finalHtmlStringData = updatedHtmlStringData

  return (
    <>
      <SEO ghostData={finalPage} pageType="blogPage" />
      <main className="flex-grow">
        <div
          className="relative max-w-6xl mx-auto h-0 pointer-events-none"
          aria-hidden="true"
        >
          <PageIllustration />
        </div>
        <HeroFeatures {...finalPage} />
        <section id="how-feature-works">
          <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="py-12 md:py-20 border-t border-gray-800">
              <FeaturesZigzagList
                htmlStringData={finalHtmlStringData}
                translatedFeatures={translatedData?.features}
              />
            </div>
          </div>
        </section>
        <AIProductionAgent slug={finalPage.slug} />
        <ProcessSecurity />
        <TestimonialsCarousel />
        <TrustedBy />
        <HallOfFame />
        <Cta slug={finalPage.slug} />
        <Faqs htmlStringData={finalHtmlStringData} items={translatedData?.faqs} />
        <Partners />
        <CalendlyBook />
      </main>
    </>
  )
}

export default PageFeature

export const postQuery = graphql`
  query GhostPageQuery($slug: String!) {
    ghostPage(slug: { eq: $slug }) {
      ...GhostPageFields
      featureImage {
        childImageSharp {
          gatsbyImageData(width: 1600, quality: 100, formats: [AUTO, WEBP])
        }
      }
    }
    allGhostSettings {
      edges {
        node {
          og_title
          og_description
        }
      }
    }
  }
`
